import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const CreditCrad = ({ size = 35, ...props }: { size?: number }) => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
    >
      <G clipPath="url(#a)">
        <Mask
          id="b"
          width={24}
          height={24}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <Path
            fill="#fff"
            d="M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
          />
        </Mask>
        <G mask="url(#b)">
          <Path
            fill="#F2F7FF"
            d="M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
          />
          <Path
            fill="url(#c)"
            d="M20.848 17.928 9.575 24.05a1.286 1.286 0 0 1-1.735-.496l-3.681-6.603a1.252 1.252 0 0 1 .503-1.712l11.272-6.124a1.286 1.286 0 0 1 1.735.497l3.682 6.602c.34.61.114 1.377-.503 1.713Z"
          />
          <Path
            fill="#fff"
            d="m5.05 17.493.552.988a.411.411 0 0 0 .554.159l11.892-6.46a.4.4 0 0 0 .161-.548l-.55-.988a.411.411 0 0 0-.555-.159l-11.892 6.46a.4.4 0 0 0-.161.548Z"
          />
          <Path
            fill="url(#d)"
            d="m20.132 21.895-12.48 3.106a1.261 1.261 0 0 1-1.536-.919L4.333 16.75a1.278 1.278 0 0 1 .94-1.535l12.479-3.105c.684-.17 1.372.24 1.537.918l1.783 7.333a1.278 1.278 0 0 1-.94 1.535Z"
          />
          <Path
            fill="#fff"
            d="m5.027 17.487.27 1.097a.406.406 0 0 0 .493.295l13.178-3.247a.406.406 0 0 0 .3-.49l-.27-1.097a.406.406 0 0 0-.492-.295L5.327 16.997a.406.406 0 0 0-.3.49Z"
          />
          <Path
            fill="url(#e)"
            d="M18.16 15H5.59C4.712 15 4 15.628 4 16.4v7.563c0 .772.713 1.4 1.59 1.4h12.57c.877 0 1.59-.628 1.59-1.4V16.4c0-.772-.713-1.4-1.59-1.4Z"
          />
          <Path
            fill="url(#f)"
            d="M8.443 18.887h-2.76c-.205 0-.37-.185-.37-.414V16.71c0-.228.165-.413.37-.413h2.76c.204 0 .37.185.37.413v1.764c0 .229-.166.414-.37.414Z"
          />
          <Path
            fill="#fff"
            d="M18.438 16.469h-2.632a.259.259 0 1 0 0 .518h2.632a.26.26 0 1 0 0-.518ZM7.943 21.91H6.182a.432.432 0 1 0 0 .863h1.761a.432.432 0 1 0 0-.864ZM11.443 21.91H9.682a.432.432 0 1 0 0 .863h1.761a.432.432 0 1 0 0-.864ZM14.943 21.91h-1.761a.432.432 0 1 0 0 .863h1.761a.432.432 0 1 0 0-.864ZM18.443 21.91h-1.761a.432.432 0 1 0 0 .863h1.761a.432.432 0 1 0 0-.864ZM18.442 17.332h-1.581a.26.26 0 1 0 0 .518h1.581a.26.26 0 1 0 0-.518Z"
          />
        </G>
        <Rect
          width={24}
          height={24}
          fill="#D9D9D9"
          rx={2.65}
          style={{
            mixBlendMode: 'saturation',
          }}
        />
      </G>
      <Defs>
        <RadialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(133.941 7.617 8.789) scale(19.9414 18.5268)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D7E6FF" />
          <Stop offset={1} stopColor="#7192C7" />
        </RadialGradient>
        <RadialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(148.628 8.568 9.535) scale(20.0763 18.4163)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#BAD4FF" />
          <Stop offset={1} stopColor="#2364CD" />
        </RadialGradient>
        <RadialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(144.788 6.789 10.78) scale(16.2775 14.2623)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-3.07701 2.42842 -2.06286 -2.61382 8.259 16.45)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="a">
          <Rect width={24} height={24} fill="#fff" rx={2.65} />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
export default CreditCrad
